import { render, staticRenderFns } from "./ButtonRounded.vue?vue&type=template&id=44d9d96b&scoped=true"
import script from "./ButtonRounded.vue?vue&type=script&lang=js"
export * from "./ButtonRounded.vue?vue&type=script&lang=js"
import style0 from "./ButtonRounded.vue?vue&type=style&index=0&id=44d9d96b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d9d96b",
  null
  
)

export default component.exports